import { atom } from "recoil"
import { FolderTree } from "../../api-client-nswag/custompermission-client"

export const folderTreeState = atom<FolderTree>({
  key: "folderTree/state",
  default: [],
})